import releaseInfo from "@/../release-info.json"
import { SofiaEnvironment } from "@/sofia-environment"

type ReleaseInfo = { version: string; hyperLink?: string }

const HYPER_LINK = "https://dev.azure.com/medgate-ag/Sofia/_git/sofia?path=/&version=GC{commitSha}&_a=history"

const getSofiaReleaseInfo = (sofiaVersion: SofiaVersion): ReleaseInfo => {
  const isProd = SofiaEnvironment.AreEndUsersOnEnvironment

  if (isProd) {
    return {
      version: sofiaVersion.sourceBranch.split("release/").at(1) ?? sofiaVersion.imageTag,
      hyperLink: undefined,
    }
  }

  return {
    version: sofiaVersion.sourceBranch.startsWith("release/")
      ? sofiaVersion.imageTag
      : sofiaVersion.sourceCommit.slice(0, 8),
    hyperLink: HYPER_LINK.replace("{commitSha}", sofiaVersion.sourceCommit),
  }
}

export const ReleaseInfo = () => {
  const { version, hyperLink } = getSofiaReleaseInfo(releaseInfo)
  return (
    <div data-testid="left-app-version" className="text-on-surface-disabled mt-5 text-xs leading-4 tracking-[0.25px]">
      {hyperLink ? (
        <a href={hyperLink} target="_blank" rel="noreferrer">
          {version}
        </a>
      ) : (
        version
      )}
    </div>
  )
}
